import axios from 'axios';

const service = axios.create({
  // baseURL: process.env.VUE_APP_API_URL,
});

service.interceptors.request.use(config => {
  config.headers['Authorization'] = ``;
  return config;
}, error => {
  return Promise.reject(error);
});


service.interceptors.response.use(response => {
  if (response.data.code !== 200) {
    return Promise.reject(new Error(response.data.result || '发生错误'));
  }
  return response.data.data;
}, error => {
  return Promise.reject(error);
});

class AxiosService {
  constructor() {
    if (AxiosService.instance) {
      return AxiosService.instance;
    }
    AxiosService.instance = this;
  }

  // GET 请求
  get(url, params = null) {
    return service.get(url, { params });
  }

  // POST 请求
  post(url, data = null, params = null, responseType) {
    return service.post(url, data, { params, responseType });
  }

  // DELETE 请求
  delete(url, params = null) {
    return service.delete(url, { params });
  }
}

const axiosService = new AxiosService();

export default axiosService;
